var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('h2',[_vm._v("Dashboard")]),_c('Button',{attrs:{"label":"Logout","icon":"pi pi-sign-out","iconPos":"right"},on:{"click":function($event){return _vm.logoutUser()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }